<template>
    <div>
        <default-navigation navbarClass="bg-primary" ref="navigation"></default-navigation>
        <section class="bg-primary pt-0">
            <div class="custom-container">
                <div class="row justify-content-center">
                    <div class="col-xl-8 text-center">
                        <h1>Een onderzoek versturen</h1>
                        <p>Beste {{ user.name }},</p>
                        <p class="mb-4">
                            Hieronder kunt u e-mailadressen toevoegen aan het onderzoek.
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <section class="pt-0 min-margin">
            <div class="custom-container">
                <div class="row justify-content-center">
                    <div class="col-xl-6">
                        <div class="form-floating mb-3">
                            <input type="text" class="form-control disabled" :value="user.name" readonly id="name">
                            <label for="name">Uw naam</label>
                        </div>
                        <div class="form-floating mb-3">
                            <input type="text" class="form-control disabled" :value="user.email" readonly id="email">
                            <label for="email">Uw e-mailadres</label>
                        </div>
                        <div class="form-floating mb-3">
                            <input type="text" class="form-control disabled" :value="inquiry !== null ? inquiry.department : ''" readonly id="department">
                            <label for="department">Naam van de afdeling die uw wilt onderzoeken</label>
                        </div>
                        <div class="form-floating mb-3">
                            <input type="text" class="form-control disabled" :value="inquiry !== null ? formatDate(inquiry.deadline) : ''" readonly id="deadline">
                            <label for="deadline">Uiterste inleverdatum</label>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="alert alert-warning col-xl-5 mt-3 d-flex" role="alert">
                        <i class="fi fi-rr-bell-ring me-2"></i>
                        <span>Alle antwoorden worden anoniem opgeslagen. De resultaten kunnen niet herleid worden naar een persoon.</span>
                    </div>
                    <div class="col-xl-8 text-center mt-3">
                        <p>Vul hieronder de e-mail adressen in van de medewerkers die u een vragenlijst wil sturen. De groep kan zo groot en divers zijn als u wil, maar om bruikbare conclusies te
                           kunnen trekken is het belangrijk de groep zo homogeen mogelijk te maken. Kies bijvoorbeeld voor alle medewerkers van de keuken, of de administratie. </p>
                    </div>
                    <div class="alert alert-warning col-xl-5 mt-3 d-flex" role="alert">
                        <i class="fi fi-rr-bulb me-2"></i>
                        <span>Heb je een rij in Excel met alle e-mailadressen? Of een tekstbestand met alle e-mailadressen? Plak ze gemakkelijk in een onderstaand veld, ze worden dan automatisch verspreid over de velden.</span>
                    </div>
                </div>
                <div class="row justify-content-center mt-4">
                    <div class="col-xl-6 text-center">
                        <template v-if="inquiry !== null && inquiry.emailAddresses.length > 0">
                            <div class="form-floating mb-3" v-for="(email, i) in inquiry.emailAddresses">
                                <input type="text" class="form-control disabled" :value="email" readonly :id="'invitee[' + i + ']'">
                                <label :for="'invitee[' + i + ']'">Genodigde</label>
                            </div>
                        </template>

                        <form class="text-center" autocomplete="off" method="get" @submit="cancelSubmit($event)">
                            <TextField v-for="i in amountFields" :cls="(i === 1 && hasError('recipient_email') ? 'is-invalid' : '' )" name="recipient_email[]" :autocomplete="false"
                                       placeholder="naam@example.com"
                                       :title="'E-mailadres ' + i"
                                       :ref="'email-' + i"
                                       :key="i" />
                            <transition name="fade" mode="out-in">
                                <div class="alert alert-warning errors col-12 d-flex" role="alert" v-if="(inquiry !== null && (this.amountFields + inquiry.emailAddresses.length >= 100))">
                                    <i class="fi fi-rr-exclamation me-2"></i>
                                    <span>Maximaal 100 e-mailadressen toegestaan!</span>
                                </div>
                                <a href="#" class="ms-3" @click="incrementFields($event)" v-if="(inquiry !== null && (this.amountFields + inquiry.emailAddresses.length < 100))"><i
                                    class="fi fi-rr-plus me-2"></i> Nog een
                                                                    adres
                                                                    toevoegen</a>
                            </transition>
                            <div class="form-check justify-content-center d-flex mt-5 mb-5">
                                <input :class="'form-check-input' + (hasError('permission') ? ' is-invalid' : '')" type="checkbox" value="1" name="permission" id="flexCheckDefault">
                                <label class="form-check-label ms-3 gray-500" for="flexCheckDefault">
                                    Ja, ik heb toestemming om deze adressen te gebruiken voor dit onderzoek
                                </label>
                            </div>
                        </form>
                        <a :class="'btn btn-primary mx-auto' + (disabled ? ' disabled' : '')" @click="submit($event)">E-mailadressen toevoegen</a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import TextField from "../../includes/TextField";
import InquiryService from "../../../services/InquiryService";
import {DateTime} from "luxon";
import axios from "axios";

export default {
    name:       'EditInquiry',
    components: {
        TextField
    },
    data() {
        return {
            disabled:     false,
            name:         null,
            email:        null,
            department:   null,
            deadline:     null,
            amountFields: 1,
            inquiry:      null,
            user:         {
                name:  null,
                email: null
            },
            errors:       [],
        }
    },
    watch: {},
    beforeRouteEnter(to, from, next) {
        InquiryService.getInquiry(to.params.token, to.params.inquiryId).then(({ user, inquiry }) => {
            if(!user) {
                throw 'User not found';
            }

            next((vm) => {
                vm.user         = user;
                vm.inquiry      = inquiry;
                vm.amountFields = 1;
            });
        }).catch((error) => {
            next({ path: '/' });
        });
    },
    methods: {
        incrementFields(event) {
            event.preventDefault();

            this.amountFields++;
        },
        hasError(field) {
            return this.errors.hasOwnProperty(field);
        },
        formatDate(date) {
            return DateTime.fromJSDate(new Date(date)).setLocale('nl').toFormat('dd LLL yyyy');
        },
        submit(event) {
            event.preventDefault();

            this.disabled = true;

            const defaultText             = event.currentTarget.innerHTML;
            event.currentTarget.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';

            const formData = new FormData(
                this.$el.querySelector('form')
            );

            const buttonElement = event.currentTarget;
            const vm            = this;

            axios.post('/api/user/' + this.$route.params.token + '/add-emails/' + this.$route.params.inquiryId, formData).then((response) => {
                if(response.data.success === true) {
                    sessionStorage.setItem('inquiry-success', response.data.token)

                    this.$router.push({ path: '/onderzoeken/' + this.$route.params.token + '?opgeslagen=success' });
                }
            }).catch((error) => {
                buttonElement.innerHTML = defaultText;

                vm.errors   = error.response.data.errors;
                vm.disabled = false;

                setTimeout(() => {
                    document.querySelector('.errors').scrollIntoView({ behavior: 'smooth' });
                }, 300);
            })
        },
        setEmailAddresses(emails, pastedFrom) {

            if(emails.length > 0) {
                for(let i in this.$refs) {
                    if(i.startsWith('email')) {
                        if(this.$refs[i][0] === pastedFrom) {
                            this.$refs[i][0].$data.value = emails.shift();

                        } else if(this.$refs[i][0].$data.value === null) {
                            this.$refs[i][0].$data.value = emails.shift();

                        }
                    }
                }

                if(emails.length > 0) {
                    this.amountFields = (this.amountFields + emails.length) > 100 ? 100 : this.amountFields + emails.length;

                    Vue.nextTick(() => {
                        for(let i in this.$refs) {
                            if(i.startsWith('email')) {
                                if(this.$refs[i][0].$data.value === null) {
                                    this.$refs[i][0].$data.value = emails.shift();
                                }
                            }
                        }
                    });
                }
            }
        },
        cancelSubmit(event) {
            event.preventDefault();
        }
    },
    mounted() {
        this.$refs.navigation.showButton = true;
    }
}
</script>
